// extracted by mini-css-extract-plugin
export default {"InstructionText":"LoginSecure1_InstructionText__PSCFx","ErrorText":"LoginSecure1_ErrorText__oGnHY","LogoutInsteadText":"LoginSecure1_LogoutInsteadText__IC9pR"};